import { comma, pct, accuracyLabel, formatMonth } from "../constants";

const td = { border: "1px solid #333", padding: "4px 8px", fontSize: 12 };
const th = { ...td, background: "#e5e7eb", fontWeight: 700 };

export default function SalarySlipPrint({ slip, form, onClose }) {
  if (!slip) return null;

  const deduction = parseFloat(form.deduction) || 0;
  const bonus = parseFloat(form.bonus) || 0;
  const baseSalary = parseFloat(form.base_salary) || 0;
  const net = baseSalary - deduction + bonus;

  return (
    <div
      className="slip-print-overlay"
      style={{
        position: "fixed", inset: 0, background: "#0009", zIndex: 2000,
        display: "flex", flexDirection: "column", alignItems: "center",
        overflowY: "auto", padding: "20px 0",
      }}
    >
      <style>{`
        .slip-print-page, .slip-print-page * { box-sizing: border-box; }
        @media print {
          .no-print { display: none !important; }
          html, body { margin: 0 !important; padding: 0 !important; }
          body * { visibility: hidden; }
          .slip-print-page, .slip-print-page * { visibility: visible; }
          .slip-print-page {
            position: absolute; inset: 0; margin: 0 !important;
            box-shadow: none !important;
            width: 100% !important; max-width: 100% !important; min-height: 0 !important;
          }
          @page { size: A4; margin: 12mm; }
        }
      `}</style>

      <div className="no-print" style={{ display: "flex", gap: 10, marginBottom: 14 }}>
        <button
          onClick={() => window.print()}
          style={{
            background: "#22c55e", color: "#fff", border: "none", borderRadius: 8,
            padding: "10px 22px", fontSize: 14, fontWeight: 700, cursor: "pointer",
          }}
        >
          🖨️ طباعة
        </button>
        <button
          onClick={onClose}
          style={{
            background: "#475569", color: "#fff", border: "none", borderRadius: 8,
            padding: "10px 22px", fontSize: 14, fontWeight: 700, cursor: "pointer",
          }}
        >
          إغلاق
        </button>
      </div>

      <div
        className="slip-print-page"
        style={{
          background: "#fff", color: "#111", width: "210mm", minHeight: "297mm",
          padding: "14mm", boxShadow: "0 0 24px #0006", fontFamily: "Arial, sans-serif",
          direction: "rtl",
        }}
      >
        <h2 style={{ textAlign: "center", margin: "0 0 4px", fontSize: 18 }}>
          ملخص تقرير مراقبة الكاميرات — {formatMonth(slip.month)}
        </h2>
        <p style={{ textAlign: "center", margin: "0 0 16px", fontSize: 13, color: "#444" }}>
          اسم المراجع: <strong>{slip.reviewer_name}</strong>
        </p>

        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 14 }}>
          <thead>
            <tr>
              <th style={th}>المحطة</th>
              <th style={th}>عدد الردود التشغيلية</th>
              <th style={th}>عدد ردود الكاميرات</th>
              <th style={th}>فرق الردود</th>
            </tr>
          </thead>
          <tbody>
            {slip.stations.map((s, i) => (
              <tr key={i}>
                <td style={td}>{s.station_name}</td>
                <td style={{ ...td, textAlign: "center" }}>{comma(s.op)}</td>
                <td style={{ ...td, textAlign: "center" }}>{comma(s.cam)}</td>
                <td style={{ ...td, textAlign: "center" }}>{comma(s.op - s.cam)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td style={{ ...th, textAlign: "right" }}>الإجمالي</td>
              <td style={{ ...th, textAlign: "center" }}>{comma(slip.total_op)}</td>
              <td style={{ ...th, textAlign: "center" }}>{comma(slip.total_cam)}</td>
              <td style={{ ...th, textAlign: "center" }}>{comma(slip.total_diff)}</td>
            </tr>
          </tfoot>
        </table>

        {slip.diff_reasons?.length > 0 && (
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 14 }}>
            <thead>
              <tr>
                <th style={th} colSpan={2}>أسباب الفروقات هذا الشهر</th>
              </tr>
            </thead>
            <tbody>
              {slip.diff_reasons.map((r) => (
                <tr key={r.reason}>
                  <td style={td}>{r.reason}</td>
                  <td style={{ ...td, textAlign: "center", width: 90 }}>{r.count} يوم</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 14 }}>
          <tbody>
            <tr>
              <td style={th}>عدد المواقع</td>
              <td style={td}>{slip.station_count}</td>
              <td style={th}>إجمالي عدد الأيام لم يتم عملها</td>
              <td style={td}>{slip.days_not_worked} من {slip.days_in_month}</td>
            </tr>
            <tr>
              <td style={th}>نسبة الدقة المراجعة</td>
              <td style={td}>{slip.accuracy != null ? pct(slip.accuracy) : "—"}</td>
              <td style={th}>تقييم أداء المراجع</td>
              <td style={td}>{slip.accuracy != null ? accuracyLabel(slip.accuracy) : "—"}</td>
            </tr>
            <tr>
              <td style={th}>نسبة إرسال الصور قبل 9 صباحًا</td>
              <td style={td}>{slip.before_pct != null ? pct(slip.before_pct) : "—"}</td>
              <td style={th}>نسبة إرسال الصور بعد 9 صباحًا</td>
              <td style={td}>{slip.after_pct != null ? pct(slip.after_pct) : "—"}</td>
            </tr>
            <tr>
              <td style={th}>نسبة لم يتم إرسال الصور خلال اليوم</td>
              <td style={td} colSpan={3}>{slip.not_sent_pct != null ? pct(slip.not_sent_pct) : "—"}</td>
            </tr>
          </tbody>
        </table>

        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 20 }}>
          <thead>
            <tr>
              <th style={th}>الراتب الأساسي</th>
              <th style={th}>الخصم (ريال)</th>
              <th style={th}>إجمالي الحافز</th>
              <th style={th}>صافي المستحق</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ ...td, textAlign: "center" }}>{comma(baseSalary)}</td>
              <td style={{ ...td, textAlign: "center" }}>{comma(deduction)}</td>
              <td style={{ ...td, textAlign: "center" }}>{comma(bonus)}</td>
              <td style={{ ...td, textAlign: "center", fontWeight: 800 }}>{comma(net)}</td>
            </tr>
          </tbody>
        </table>

        {form.notes && form.notes.trim() && (
          <div style={{ marginBottom: 16 }}>
            <p style={{ fontSize: 12, fontWeight: 700, margin: "0 0 4px" }}>
              ملاحظات:
            </p>
            <div style={{ ...td, minHeight: 30, whiteSpace: "pre-wrap" }}>
              {form.notes}
            </div>
          </div>
        )}

        <p style={{ fontSize: 12, fontWeight: 700, margin: "0 0 4px" }}>
          حالات العجز (تُملأ يدويًا):
        </p>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={th}>اسم المشرف</th>
              <th style={th}>التاريخ</th>
              <th style={th}>الموقع</th>
              <th style={th}>عدد الردود</th>
              <th style={th}>الحمولة</th>
              <th style={th}>القيمة</th>
              <th style={th}>عدد الردود المُثبتة على المشرف</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 6 }).map((_, i) => (
              <tr key={i}>
                {Array.from({ length: 7 }).map((__, j) => (
                  <td key={j} style={{ ...td, height: 22 }}>&nbsp;</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
